import { useState } from 'react';

interface FaqItem {
  question: string;
  answer: string;
}

const faqData: FaqItem[] = [
  {
    question: '亲亲漫画APP在哪里下载？',
    answer: '亲亲漫画提供安卓和iOS双平台APP下载。您可以直接在本页面点击下载按钮，扫码即可安装。安卓用户可通过APK直接安装，iOS用户可跳转至App Store下载。',
  },
  {
    question: '亲亲漫画是免费的吗？',
    answer: '是的，亲亲漫画完全免费！我们致力于为广大漫画爱好者提供免费的韩漫、日漫、国漫在线阅读服务。所有漫画均可免费阅读，无隐藏收费。',
  },
  {
    question: '支持哪些类型的漫画？',
    answer: '亲亲漫画涵盖韩漫、日漫、国漫等多种类型，包括恋爱、奇幻、动作、搞笑、悬疑、耽美、百合等丰富分类。无论你喜欢什么类型的漫画，都能在这里找到心仪的作品。',
  },
  {
    question: '什么是下拉式阅读？',
    answer: '下拉式阅读是一种专为手机端优化的阅读方式。您只需向下滑动屏幕即可连续阅读漫画内容，无需翻页操作，阅读体验更加流畅自然，特别适合条漫格式的韩漫和国漫。',
  },
  {
    question: '支持离线缓存吗？',
    answer: '支持！下载亲亲漫画APP后，您可以将喜欢的漫画缓存到本地，在没有网络的情况下也能随时随地畅享漫画阅读。缓存功能完全免费，不限制缓存数量。',
  },
  {
    question: '漫画更新频率如何？',
    answer: '亲亲漫画每日更新，热门连载漫画保持与官方同步更新。您可以通过APP开启追更提醒，第一时间收到更新的通知，再也不用担心错过喜欢的漫画更新。',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="py-14 md:py-20">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">常见问题</h2>
          <p className="text-sm text-foreground-500 mt-2">关于亲亲漫画的常见疑问，这里都有答案</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="rounded-xl border border-background-200/70 overflow-hidden transition-all duration-300"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-5 text-left hover:bg-background-100 transition-colors duration-200 cursor-pointer"
              >
                <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">{faq.question}</span>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 rounded-full transition-all duration-300 ${
                  openIndex === index ? 'bg-primary-500 text-background-50 rotate-45' : 'bg-background-200 text-foreground-600'
                }`}>
                  <i className="ri-add-line text-sm"></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 ease-in-out ${
                  openIndex === index ? 'max-h-60 opacity-100' : 'max-h-0 opacity-0'
                } overflow-hidden`}
              >
                <div className="px-5 pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}